import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import { Modal } from '@vinted/web-ui';
import { jsx as _jsx } from "react/jsx-runtime";

class SearchSubscribeModal extends PureComponent {
  constructor() {
    super(...arguments);

    _defineProperty(this, "translate", id => this.props.intl.formatMessage({
      id: "saved_searches.first_time_subscribe_modal.".concat(id)
    }));
  }

  render() {
    return /*#__PURE__*/_jsx(Modal, {
      show: this.props.isOpen,
      testId: "search-subscribe-modal",
      title: this.translate('title'),
      body: this.translate('text'),
      actions: [{
        text: this.translate('action'),
        style: Modal.ActionStyling.Filled,
        callback: this.props.onClose,
        testId: 'search-subscribe-modal-close-button'
      }]
    });
  }

}

_defineProperty(SearchSubscribeModal, "defaultProps", {
  isOpen: false,
  onClose: null
});

export default injectIntl(SearchSubscribeModal);